module.exports = __webpack_public_path__ + "static/img/NOCollection.d08b3e8d.png";